<template>
    <div>
      <!-- Body -->
      <div class="body">
        <div>
            <themed-table 
                :headers="this.bedManagerService.packages.headers" 
                :data="transformedData" 
                :toolbarDropdown="packageFilterOptions"
                :toolbarDropdownValue="selectedPackageFilter"
                @toolbar-dropdown-change="onPackageFilterChange"
                @actionClick="onActionClick"
                :pagination="{
                    perPage: this.bedManagerService.packages.query.limit,
                  total: this.bedManagerService.packages.total,
                  page: Math.floor(this.bedManagerService.packages.query.skip / this.bedManagerService.packages.query.limit) + 1
                }"
                :version="version"
                :sortingEnabled=true 
                :filteringEnabled=false
                :paginationEnabled="this.bedManagerService.packages.total > this.bedManagerService.packages.query.limit" 
                @paginationChange="(event) => {
                    this.bedManagerService.packages.query.skip = this.bedManagerService.packages.query.limit * (event.page - 1);
                    this.bedManagerService.packages.query = {...this.bedManagerService.packages.query};
                }"
                @searchChange="(event) => {
                    const query = this.bedManagerService.packages.query;
                    query.skip = 0; // Resets skip as the search params change
                    Object.keys(event).forEach((key) => {
                        if (event[key]) query[key] = event[key].trim();
                        else delete query[key];
                    })
                    this.bedManagerService.packages.query = {...query};
                }"
                @sortingChange="(event) => {
                  if (event === 'delete') {
                    delete this.bedManagerService.packages.query.sortProperty;
                    delete this.bedManagerService.packages.query.sortDirection;
                    this.bedManagerService.packages.query = { ...this.bedManagerService.packages.query };
                  } else {
                    this.bedManagerService.packages.query = { ...this.bedManagerService.packages.query, sortProperty: event.type, sortDirection: event.direction };
                  }
                }"
                :addItem="{ label: 'Package', element: CreatePackages }"
                ></themed-table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";
  import BedManagerService from "../BedManager.service";
  import CreatePackages from "./CreatePackages.vue";

  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-table', ThemedTable);
  
  export default {
    name: "Packages",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,
        // Singleton Pattern Service
        // Contains State and API Requests
        bedManagerService: BedManagerService,
       selectedPackageFilter: 'available',
        packageFilterOptions: [
          { value: 'available', text: 'Available Packages' },
          { value: 'archived', text: 'Archived Packages' },
          { value: 'all', text: 'All Packages' }
        ],
        packagesInterval: null,

        CreatePackages: CreatePackages,
      };
    },
    computed: {
      version() {
      return this.bedManagerService ? this.bedManagerService.appVersion : '0.0.0';
      },
      transformedData() {
        if (Array.isArray(this.bedManagerService.packages.data)) {
            this.bedManagerService.packages.data.forEach((item) => {
                if (item.created) {
                  item.created = moment(item.created).format("MMMM Do, YYYY [at] h:mm A");
                }
                if (item.modified) {
                  item.modified = moment(item.modified).format("MMMM Do, YYYY [at] h:mm A");
                }
                item.additional = `<div style="display: flex; flex-direction: column; gap: 5px;">
                  ${item.pathOnSensor ? `<span><b>Path on Sensor</b>: ${item.pathOnSensor}</span>` : ''}
                  ${item.zipSourceFolder ? `<span><b>Source Folder</b>: ${item.zipSourceFolder}</span>` : ''}
                  ${item.command ? `<span><b>Command</b>: ${item.command}</span>` : ''}
                </div>`;
            })
        }
        return this.bedManagerService.packages.data;
      },
      currentQuery() {
        if (this.bedManagerService.packages.query) {
            return this.bedManagerService.packages.query;
        }
        return null;
      },
    },
    watch: {
        currentQuery: {
        deep: true, 
        handler() {
      this.bedManagerService.fetchPackages();
    }
  }
    },
      mounted() {
      
      this.bedManagerService.packages.query = {
        
        ...this.bedManagerService.packages.query,
        queryFilter: 'available',
        skip: 0,
      };
      this.bedManagerService.fetchPackages();

      // Set Packages Poll On Mount
      this.packagesInterval = setInterval(() => {
        this.bedManagerService.fetchPackages();
      }, this.bedManagerService.DEFAULT_POLL_INTERVAL_IN_SECS * 1000);

      // Used as ON DESSTROY
      this.$router.afterEach(() => {
        try {
          clearInterval(this.packagesInterval);
        } catch (e) { this.console.log(e); }
      });
    },
    unmounted() {},
    methods: {
    onPackageFilterChange(value) {
      this.selectedPackageFilter = value;
      const query = { ...this.bedManagerService.packages.query, skip: 0 };
      query.queryFilter = value;
      this.bedManagerService.packages.query = { ...query };
    },
      onActionClick(item) {
      const isArchieved = !item.isArchieved;
      this.bedManagerService.updatePackageArchiveStatus({
        packageId: item._id,
        isArchieved,
      });
    },
    
          },
    };
  </script>
  
  <!-- Header Styles -->
  <style lang="scss" scoped>
    .page-header {
      &__flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics-item {
        font-size: .7em;
        display: flex;
        flex-direction: column;
      }
    }

    .body {
        &__inner {
            padding: 15px;
        }
    }
  </style>  
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }</style>
  